<template>
  <div class='aiMap'>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <div class="top">
      <tk-image class="top-bg" oraign src="https://qingbo-oss.oss-cn-beijing.aliyuncs.com/e014c041-fd5a-4ba7-98b3-e6d08c2d2e8c.png"></tk-image>
      <!-- 详情顶部 -->
      <div class="detail-header w" v-if="aiInfo.courseMajor">
        <!-- 课程顶部提示 -->
        <div class="fbox fbox-jb fbox-w">
          <div class="header-row fbox fbox-ac fg1" style="minWidth: 150px">
            <!-- <img class="fsh" src="https://dummyimage.com/100x100">
            <p class="name fsh">Hi，E.Massey</p> -->
            <!-- <p class="color-black f20 fg1">您的定制专业学习路径包括{{(aiInfo.courseMajor.expandCourse + aiInfo.courseMajor.kernelCourse + aiInfo.courseMajor.ordinaryCourse) || 0}}门课程，共{{aiInfo.courseMajor.allCourse || 0}}课节。快开启您的学习之旅吧</p> -->
            <p class="color-black f20 fg1">您的定制专业学习路径包括{{(aiInfo.courseMajor.expandCourse + aiInfo.courseMajor.kernelCourse + aiInfo.courseMajor.ordinaryCourse) || 0}}门课程，共{{aiInfo.courseMajor.allPreinstallNum || 0}}个课时。快开启您的学习之旅吧</p>
          </div>
          <div @click="customization" class="btn fsh tc f20">
            定制学习路线
          </div>
        </div>
        <div class="fbox fbox-w">
          <img class="picture" :src="aiInfo.courseMajor.img">
          <div class="detail-header-right fg1">
            <!-- 标题 -->
            <div class="title fbox fbox-ac">
              <p class="title-lable tc fsh m-r-5" v-if="aiInfo.courseMajor && aiInfo.courseMajor.short">{{aiInfo.courseMajor.short}}</p>
              <p class="fg1 color-black f24 font-weight-b ell">{{aiInfo.courseMajor.name}}</p>
            </div>
            <!-- 简介 -->
            <div class="synopsis f16 color-gray" >
              {{aiInfo.courseMajor.synopsis}}
            </div>
            <!-- 按钮 -->
            <div class="btn-box fbox fbox-ac fbox-jb fbox-w">
              <!-- 老师 -->
              <div class="teacherList fbox fg1  fbox-w">
                <div class="teacher tc" v-for="(teacher, i) in aiInfo.courseMajor.teacher" :key="i">
                  <tk-avatar>
                    <tk-image :src="teacherObj[teacher].headPortrait || 'http://qingbo-oss.oss-cn-beijing.aliyuncs.com/dba81e13-181d-4aa3-b872-bf15d8df199f.png'" width="100" height="100"></tk-image>
                  </tk-avatar>
                  <p class="tc f16 color-gray">{{teacherObj[teacher].nickname}}</p>
                </div>
              </div>
              <div class="btn-contener fsh fbox fbox-jb">
                <div class="join" @click="joinCourse()">
                  加入选课
                </div>
                <div class="get" @click="getOrder()">
                  立即获取
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contener" >
      <div class="w">
        <div class="ai-container-item" v-for="(item, index) in courseList" :key="index" >
          <aiClass :courseObj='courseObj' :teacherObj='teacherObj' :courseList='item' :activeIndex='index' @toCourseDetail='toCourseDetail($event)'   />
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <Modal v-model="modal" scrollable width="60%" :styles="{ top: '20%' }" :footer-hide='true' :lock-scroll='false'>
      <div v-for="(item, index) in classify" :key='index'>
        <p class="color-black f24 font-weight-b">{{item.title}}</p>
        <div class="customization-container fbox fbox-w fbox-ac">
          <p v-for="(t, i) in item.child" :key='i' class="f20 tc" :class="{active:activeId === t.objectId}" @click="changeId(t.objectId)">{{t.name}}</p>
        </div>
      </div>
      <div class="sub-btn" @click="submit">确认</div>
    </Modal>
  </div>
</template>

<script>
import aiClass from '@/components/aiClass'
export default {
  name: 'aiMap',
  components: {
    aiClass
  },
  data () {
    return {
      teacherList: [
        { name: '陈思思', img: 'https://dummyimage.com/100x100' }, { name: '陈思思', img: 'https://dummyimage.com/100x100' }, { name: '陈思思', img: 'https://dummyimage.com/100x100' }
      ],
      classList: [
      ],
      modal: false,
      classify: [
        {
          title: '选择专业定制',
          child: []
        },
        {
          title: '选择岗位定制',
          child: []
        }
      ],
      activeId: '',
      aiAll: [],
      aiInfo: {},
      indexs: 0,
      courseObj: {},
      teacherObj: {},
      courseList: [],
      spinShow: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.getAiMap()
      this.spinShow = false
    },
    // 定制学习路线
    customization () {
      this.modal = true
    },

    async getAiMap () { // 获取课程详情
      let res = await this.$tkParse.getList('/classes/aiMap', {
        params: {
          include: 'courseMajor,courseMajor.preinstallMajor,preinstallMajor',
          where: {
            preinstallMajor: {
              $exists: true
            }
          }
        }
      })
      if (!res.length) {
        this.$Message.error('暂未设置学习地图')
        return
      }
      for (let index = 0; index < res.length; index++) {
        const element = res[index]
        if (element.preinstallMajor.type === '00') {
          this.classify[0].child.push(element.preinstallMajor)
        } else {
          this.classify[1].child.push(element.preinstallMajor)
        }
      }
      this.aiAll = res
      this.getElse()
    },
    async getElse () {
      let arr = this.aiAll
      let courseIdArr = []
      this.activeId = arr[this.indexs].preinstallMajor.objectId
      if (arr[this.indexs].courseMajor.course) {
        arr[this.indexs].courseMajor.course.forEach(item => {
          courseIdArr.push(item.course)
        })
      }
      if (arr[this.indexs].courseMajor.course && arr[this.indexs].courseMajor.course.length) {
        await this.getCourse(arr[this.indexs].courseMajor.course)
      } else {
        this.courseList = [
          {
            name: '基础课程',
            course: [],
            num: 0
          },
          {
            name: '核心课程',
            course: [],
            num: 0
          },
          {
            name: '拓展课程',
            course: [],
            num: 0
          }
        ]
      }
      let teacherArr = await this.$tkParse.post('/web/getAllTeacher', arr[this.indexs].courseMajor.teacher) // 请求云代码
      this.teacherObj = teacherArr.data
      this.aiInfo = arr[this.indexs]
    },
    // 获取课程列表
    async getCourse (course) {
      // let idArr = []
      // course.forEach(item => {
      //   idArr.push(item.course)
      // })
      let res = await this.$tkParse.post('/web/getCourseMajor', course) // 请求云代码
      let courseList = res.data
      let ordinaryList = []
      let ordinaryNum = 0
      let ordPreinstallNum = 0
      let kernelList = []
      let kernelNum = 0
      let kerPreinstallNum = 0
      let expandList = []
      let expandNum = 0
      let expPreinstallNum = 0
      // console.log(courseList)
      courseList.forEach((item, index) => {
        switch (item.tag) {
          case '00':
            ordinaryList.push(item)
            ordinaryNum = ordinaryNum + item.num
            if (!item.preinstallNum) item.preinstallNum = 0
            ordPreinstallNum += item.preinstallNum
            break
          case '01':
            kernelList.push(item)
            kernelNum = kernelNum + item.num
            if (!item.preinstallNum) item.preinstallNum = 0
            kerPreinstallNum += item.preinstallNum
            break
          default:
            expandList.push(item)
            expandNum = expandNum + item.num
            if (!item.preinstallNum) item.preinstallNum = 0
            expPreinstallNum += item.preinstallNum
        }
      })
      this.courseList = [
        {
          name: '基础课程',
          course: ordinaryList,
          num: ordinaryNum,
          preinstallNum: ordPreinstallNum
        },
        {
          name: '核心课程',
          course: kernelList,
          num: kernelNum,
          preinstallNum: kerPreinstallNum
        },
        {
          name: '拓展课程',
          course: expandList,
          num: expandNum,
          preinstallNum: expPreinstallNum
        }
      ]
    },
    // 立即获取
    async getOrder () {
      if (this.$login(this)) { return }
      let type = '0'
      let setData = []
      let obj = {
        type: type,
        id: this.aiInfo.courseMajor.objectId
      }
      setData.push(obj)
      sessionStorage.setItem('order', JSON.stringify(setData))
      this.$push('/ordersSubmit')
    },
    // 加入选课
    async joinCourse () {
      if (this.$login(this)) { return }
      // type区分合集和课程
      let type = '0'
      let id = this.aiInfo.courseMajor.objectId
      let res = await this.$tkParse.getList('/classes/registrationCenter', {
        params: {
          where: {
            user: this.$store.state.user.objectId
          }
        }
      })

      if (res.length) {
        let idArr = []
        let putData = res[0].course
        res[0].course.forEach(item => {
          idArr.push(item.id)
        })
        if (idArr.indexOf(this.aiInfo.courseMajor.objectId) !== -1) {
          this.$Message.warning({ content: '请勿重复添加' })
          return
        }
        putData.push({ type, id })
        let put = await this.$tkParse.put(`/classes/registrationCenter/${res[0].objectId}`, {
          course: putData
        })
        if (put) {
          this.$Message.success('添加成功')
          this.$store.commit('setCarNum', this.$store.state.carNum + 1)
        } else {
          this.$Message.error('添加失败')
        }
        return
      }

      let postData = {
        user: this.$store.state.user.objectId,
        course: [
          { type, id }
        ]
      }
      let post = await this.$tkParse.post('/classes/registrationCenter', postData)
      if (post) {
        this.$Message.success('添加成功')
        this.$store.commit('setCarNum', this.$store.state.carNum + 1)
      } else {
        this.$Message.error('添加失败')
      }
    },
    // 去老师详情
    toTeacherDetail (id) {
      this.$push({
        path: '/teacherDetail',
        query: {
          id
        }
      })
    },
    toCourseDetail (id) {
      this.$push({
        path: '/classDetail',
        query: {
          id: id
        }
      })
    },
    changeId (e) {
      this.activeId = e
    },
    async submit () {
      this.modal = false
      let arr = this.aiAll
      arr.forEach((item, index) => {
        if (item.preinstallMajor.objectId === this.activeId) {
          this.indexs = index
        }
      })
      this.getElse()
    }
  }
}
</script>
<style lang="scss" scoped>
.aiMap{
  background-color: #FFEDC2;
  padding-bottom: 60px;
}
.top{
  width: 100%;
  // height: 780px;
  background-size: 100% auto;
  // position: relative;
  .top-bg{
    width: 100%;
    height: 280px;
  }
  .header-row{
    margin-bottom: 48px;
    img{
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .name{
      font-size: 32px;
      color: #333333;
      font-weight: bold;
      margin: 0 80px 0 20px;
    }
  }
  .btn{
    width: 198px;
    height: 60px;
    line-height: 60px;
    background: linear-gradient(138deg, #00C774 0%, #00C084 100%);
    border-radius: 30px;
    color: #FFFFFF;
    cursor: pointer;
  }
}
.detail-header{
  padding: 40px;
  box-sizing: border-box;
  background: #FFFFFF;
  // position: absolute;
  // margin-top: 200px;
  // left: 50%;
  // transform: translateX(-50%);
  border-radius: 23px;
  .picture{
    width: 360px;
    height: 240px;
    border: 1px solid #707070;
  }
  .detail-header-right{
    min-width: 300px;
    margin-left: 45px;
  }
  .title{
    width: 100%;
    .title-lable{
      display: inline-block;
      width: 42px;
      height: 26px;
      line-height: 26px;
      background: #DCAF80;
      border-radius: 4px;
      font-size: 16px;
      color: #ffffff;
      font-weight: 400;
    }
  }
  .synopsis{
    margin: 10px 0 20px;
    min-height: 80px;
    img{
      width: 29px;
      height: 29px;
      margin-right: 5px;
    }
    div{
      height: 50px;
    }
  }
  .teacherList{
    // width: 100%;
    // overflow-x: scroll;
    .teacher{
      margin-right: 30px;
      cursor: pointer;
      img{
        width: 55px;
        height: 55px;
        border-radius: 50%;
      }
    }
  }
  .cut-off-rule{
    width: 100%;
    height: 0px;
    border-top: 1px solid #EBEBEB;
  }
  .btn-box{
    // height: 100px;
    .btn-contener{
      width: 360px;
      div{
        width: 160px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        border-radius: 4px;
        cursor: pointer;
      }
      .join{
        border: 1px solid #EA3553;
        color: #EA3553;
      }
      .get{
        background: #EA3553;
        color: #FFFFFF;
      }
    }
  }
  .explain{
    height: 100px;
    .vertical-line{
      width: 0px;
      height: 21px;
      border-left: 1px solid #EBEBEB;
      margin: 0 38px;
    }
    .explain-left{
      div{
        margin: 0 20px 0 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
    .explain-right{
      img{
        margin: 0 10px 0 5px;
      }
    }
  }
}

.contener{
  margin-top: 30px !important;
  &:nth-child(3){
    background-image: url('https://qingbo-oss.oss-cn-beijing.aliyuncs.com/25d7d2ee-6aa3-434f-a93a-914dac148ccc.png');
  }
  &:nth-child(1){
    background-image: url('https://qingbo-oss.oss-cn-beijing.aliyuncs.com/7e5b7d3c-59c7-4206-bcb2-70523b0757dd.png');
  }
  background-image: url('https://qingbo-oss.oss-cn-beijing.aliyuncs.com/2bf959f9-dc84-4c26-a2fd-00bb0d1d17d3.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
}
// 弹窗
.customization-container{
  margin-top: 29px;
  p{
    // min-width: 122px;
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    background: #FFFFFF;
    border: 1px solid #E2E2E2;
    border-radius: 50px;
    color: #868A99;
    margin: 0 15px;
    margin-bottom: 30px;
    cursor: pointer;
    &:hover{
      color: #28B28B;
    }
  }
  .active{
    background: #28B28B;
    color: #FFFFFF !important;
    border: 1px solid #28B28B;
  }
}
.sub-btn{
  width: 220px;height: 50px;
  font-size: 20px;
  line-height: 50px;
  border-radius: 30px;
  margin: 20px auto;
}
@media(max-width: 992px) {
  #video{
    width:100%;
  }
  .detail-header{
    padding: 20px !important;
  }
  .detail-header-right{
    margin-left: 0 !important;
  }
  .picture{
    width: 100% !important;
  }
  .btn-contener{
    width: 100%  !important;
    margin-top: 10px;
    div{
      width: 45% !important;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 18px;
      border-radius: 4px;
      cursor: pointer;
    }
    .join{
      border: 1px solid #EA3553;
      color: #EA3553;
    }
    .get{
      background: #EA3553;
      color: #FFFFFF;
    }
  }
  .detail-header-right{
    min-width: 100px !important;
  }
  .header-row{
    margin-bottom: 10px !important;
  }
  .btn{
    margin: 0 auto !important;
    margin-bottom: 10px !important;
  }
}
</style>
